import * as Sentry from '@sentry/browser';

import { getDevStackMode } from './devStackMode';
import { getUserId } from './cognito';
import { webAppVersion } from '../../Version';

const SENTRY_DSN = 'https://21259d90a1191a86351ffa9aad5196a7@o188289.ingest.us.sentry.io/4507776787087360';

let isInitialized = false;

export function initializeSentry() {
    if (isInitialized) return;

    try {
        Sentry.init({
            beforeSend: (event) => {
                if (event.request?.url) event.request.url = removeUrlParameters(event.request.url);
                event.breadcrumbs?.forEach((breadcrumb) => {
                    for (const key of ['from', 'to', 'url']) {
                        const value = breadcrumb.data?.[key];
                        if (typeof value === 'string') breadcrumb.data![key] = removeUrlParameters(value);
                    }
                });
                return event;
            },
            dsn: SENTRY_DSN,
            enabled: window.location.hostname !== 'localhost',
            environment: process.env.NODE_ENV,
            integrations: [],
            sampleRate: 1, // 100% of the Sentry events are sent to their backend
            release: webAppVersion,
        });

        Sentry.setTags({
            environment: process.env.NODE_ENV,
            userId: getUserId(),
            isDevStack: getDevStackMode(),
        });

        isInitialized = true;
    } catch (error) {
        console.warn('Failed to initialize Sentry:', error);
    }
}

export function captureSentryException(exception: unknown, tags?: Record<string, string>) {
    // Initialize Sentry if not already done
    if (!isInitialized) {
        initializeSentry();
    }

    if (!tags) {
        Sentry.captureException(exception);
        return;
    }

    Sentry.withScope((scope) => {
        Object.entries(tags).forEach(([key, value]) => scope.setTag(key, value));
        Sentry.captureException(exception);
    });
}

function removeUrlParameters(url: string): string {
    return url.split(/[?#]/, 1)[0];
}
